var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.device)?_c('quick-actions',{attrs:{"className":"DeviceQuickActions","available-actions":_vm.actions,"visible-actions":_vm.options}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }